import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function Offer() {
  return <section id="offer" className="pt-6 pb-12 md:py-24 px-6 bg-cream relative overflow-hidden" data-id="element-75">
      {/* Decorative background */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-white/40 blur-3xl rounded-full pointer-events-none" data-id="element-76" />

      <div className="max-w-2xl mx-auto relative z-10 text-center" data-id="element-77">
        <FadeIn data-id="element-78">
          <div className="mb-8 md:mb-12" data-id="element-79">
            <h2 className="text-2xl md:text-4xl font-serif text-olive-900 mb-4 md:mb-6" data-id="element-80">
              You don't need to move to a remote island to live like a
              centenarian.
            </h2>
            <p className="text-xl text-stone-600" data-id="element-81">
              You just need to change how you process the world around you.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-82">
          <div className="bg-white p-6 md:p-12 rounded-xl shadow-xl border border-olive-100 mb-8 md:mb-12" data-id="element-83">
            <div className="mb-6 md:mb-8" data-id="element-84">
              <span className="text-sm font-bold tracking-widest text-gold-600 uppercase" data-id="element-85">
                Limited Time Offer
              </span>
              <div className="flex items-baseline justify-center mt-4 mb-2" data-id="element-86">
                <span className="text-5xl font-serif font-bold text-olive-900" data-id="element-87">
                  $6.39
                </span>
                <span className="ml-2 text-stone-500 line-through" data-id="element-88">$19.99</span>
              </div>
              <p className="text-stone-500 text-sm" data-id="element-89">
                One-time payment • Instant Access
              </p>
            </div>

            <Button size="lg" href="https://instaflowdp.com/cart/63195290370417:1" className="w-full md:w-auto min-w-[280px] mb-6" data-id="element-90">
              Get the Guide Now
            </Button>

            <div className="flex items-center justify-center text-sm text-stone-500" data-id="element-91">
              <ShieldCheck className="w-4 h-4 mr-2 text-olive-600" data-id="element-92" />
              <span data-id="element-93">Access for Life</span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-94">
          <div className="flex items-center justify-center space-x-4" data-id="element-95">
            <div className="h-px bg-olive-200 w-12" data-id="element-96" />
            <p className="font-serif italic text-olive-800" data-id="element-97">
              To your longevity,
            </p>
            <div className="h-px bg-olive-200 w-12" data-id="element-98" />
          </div>
        </FadeIn>
      </div>
    </section>;
}